//
//
//
//
//
//
//
//
//
//
//
//
//

import API from "~/api/api";

export default {
  components: {},
  data() {
    return {};
  },
  layout: "default-no-sticky",
  computed: {
    hero() {
      return this.pageInfo.fields.hero.table;
    },
    body() {
      return this.pageInfo.fields.page_content;
    },
    metaInfo() {
      return this.pageInfo.fields.meta_information.table;
    },
    pageSlug() {
      return this.$route.path.slice(1);
    },
  },

  head() {
    if (this.pageInfo) {
      let domain = "https://www.legalnature.com";
      let canonicalLink = domain + this.pageSlug;
      let meta = [
        { name: "description", content: this.metaInfo.description },
        { name: "keyword", content: this.metaInfo.keyword },
        { name: "og:image", content: this.metaInfo["og-image"] },
        { name: "og:title", content: this.metaInfo.title },
        { name: "og:description", content: this.metaInfo.description },
        { name: "og:type", content: "website" },
        { name: "og:url", content: canonicalLink },
      ];
      return {
        title: this.metaInfo.title,
        meta,
        link: [
          {
            rel: "canonical",
            href: canonicalLink,
          },
        ],
      };
    } else {
      return {};
    }
  },

  asyncData({ app, query, params, redirect, route, error }) {
    let pagePath = route.path.split("/")[1];
    if (pagePath === "terms-of-use") pagePath = "ln-terms-of-use";
    return Promise.all([
      API.butterPages.get(app.$axios, pagePath, {
        preview: query.preview ? 1 : 0,
      }),
    ])
      .then((results) => {
        const pageInfo = results[0];
        return {
          pagein: results[0],
          pageInfo,
          loading: false,
          error: false,
        };
      })
      .catch((e) => {
        console.error(e);
        error({ message: "Error fetching data..." });

        return {
          getServices: {},
          pageInfo: {},
          loading: false,
        };
      });
  },
};
